 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		214: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + {"0":"6962ae5","1":"5537ef9","2":"e10c5f8","3":"35fb6ae","4":"beb7ecc","5":"cdc95e7","6":"f2c99ca","7":"92c8e5e","8":"9af19d0","9":"b91c8b0","10":"165a62b","11":"7e027ba","12":"7cd911a","13":"c85164c","14":"a4b5f41","15":"0315bea","16":"97381fd","17":"2a175c0","18":"e2ba4a8","19":"917b271","20":"af42065","21":"7124e9f","22":"f8b8c0b","23":"9412bc8","24":"eb54ca9","25":"89ff435","26":"986cb55","27":"228c943","28":"3347da6","29":"2317e55","30":"d1a48f0","31":"d33116e","32":"027afeb","33":"f1d3970","34":"24894b0","35":"f5a602d","36":"0bff994","37":"4db3f5b","38":"f470950","39":"06bf269","40":"7275cbd","41":"b3c2b20","42":"01ee18a","43":"e8699f5","44":"01f34ea","45":"b11365d","46":"04fb57d","47":"beaeaae","48":"c7a436c","49":"610cd4b","50":"b10ee53","51":"eff0561","52":"bf11e89","53":"0f08426","54":"6523d09","55":"b2450ab","56":"1b8e989","57":"55cdd1a","58":"0796aa3","59":"2fe2fde","60":"9d7879f","61":"52d4e7d","62":"9730469","63":"3a16da9","64":"b638b2e","65":"16ba79b","66":"7e4ce64","67":"45fa06f","68":"62a532a","69":"e98682c","70":"94753d8","71":"ee5779c","72":"242bc61","73":"9a23147","74":"34a3f4d","75":"498647c","76":"91ae00e","77":"1d92816","78":"419248c","79":"42f1b09","80":"7a5aa67","81":"abb7b7d","82":"ed17142","83":"2b50535","84":"623238a","85":"8512abe","86":"14a5e56","87":"70078b4","88":"3248f67","89":"29cbb83","90":"df2653f","91":"df15587","92":"d6fe54e","93":"2f60365","94":"8c726f1","95":"643370d","96":"ddb9b28","97":"83a1766","98":"4cba6cd","99":"90c1554","100":"5ab376d","101":"b9df265","102":"9001b80","103":"df92cb7","104":"ed201cb","105":"535b2cb","106":"5b25233","107":"ec45fab","110":"67b1a6d","111":"b6f5e06","112":"e01a42c","113":"d8bcc8c","114":"ec7bfd5","115":"da89ba7","116":"04b98d3","117":"7afc4a2","118":"85d7ee1","119":"56eb4cf","120":"65fc42c","121":"c1933fe","122":"ef1fe8d","123":"6027d96","124":"ab94424","125":"06e41f6","126":"9ff4536","127":"0af7700","128":"07aac19","129":"96712c7","130":"c38b989","131":"a7a0449","132":"52c86c1","133":"747fb74","134":"2696986","135":"aaba45f","136":"c0f7738","137":"30ebd6f","138":"1bceba1","139":"224e394","140":"a3d65de","141":"c7767ff","142":"4465f64","143":"b63e5ea","144":"d1742f0","145":"28ef839","146":"5c398e2","147":"7950c28","148":"53c7b89","149":"4138286","150":"41c5e20","151":"55760f9","152":"27bd50f","153":"1085487","154":"5debf14","155":"0c68385","156":"2e2b0aa","157":"a54d26b","158":"864c3b0","159":"d9525df","160":"55ae167","161":"771dcc8","162":"14eb3d5","163":"d9594a3","164":"f7f3abd","165":"bb82599","166":"87a2eb8","167":"f23a71c","168":"bb2dd3a","169":"628c482","170":"3f2fae0","171":"6cd8d6d","172":"728b893","173":"4bc2b04","174":"58df979","175":"ee3edf8","176":"950d39e","177":"5a99721","178":"62c3c9c","179":"0aced2e","180":"63a03ea","181":"dcc670a","182":"b82cea0","183":"7dd8abc","184":"eb9c4aa","185":"c0c2e53","186":"db743f1","187":"02d20e4","188":"cdad3f8","189":"90b0c61","190":"6fb36e5","191":"4d8946b","192":"570716f","193":"276c606","194":"64c67e4","195":"739d77f","196":"3c1af83","197":"45e3b74","198":"55e4b84","199":"04435d8","200":"f94379f","201":"e7870bc","202":"968e47a","203":"6ede461","204":"735292f","205":"429d14c","206":"f4bd56f","207":"8aff599","208":"fe76470","209":"d33629e","210":"2e86274","211":"78bf6ff","212":"f7d409f","213":"cf74469","216":"2394e73","217":"aec18e0","218":"4ae552c","219":"b9d9cae","220":"9a22246","221":"1bab1a6","222":"def3e43","223":"685fbc6","224":"3a76d73","225":"27720b0","226":"d757dd1","227":"3e90601","228":"8748378","229":"0291b3b","230":"fe3a098","231":"49d6112","232":"274e939","233":"1d4a1ba","234":"9cb6850","235":"ec0d9ca","236":"c41f4b5","237":"9d4ff17","238":"a487851","239":"4ffbcdc","240":"5a129fa","241":"9d591ab","242":"e922552","243":"dbf4059","244":"5a67e93","245":"ed50521","246":"50c58f8","247":"255affa","248":"8533b38","249":"c1c0f0f","250":"0adb229","251":"4d0c671","252":"e3bdde7","253":"100199b","254":"9a5df69","255":"e4a80e5","256":"8a5b435","257":"cecfef3","258":"08cbb85","259":"75f948b","260":"e388e2e","261":"a8cdff1","262":"5848ba8","263":"215770e","264":"ab56376","265":"1fb35e1","266":"7039584","267":"473fc22","268":"7208e7a","269":"b6bee8b","270":"13160e6","271":"2671ba2","272":"4711fcc","273":"30d9b22","274":"cffac62","275":"fc10bc1","276":"b68bab2","277":"3d34c3a","278":"ec4f643","279":"327bd8b","280":"734bc79","281":"478fc30","282":"70d9e50","283":"f9b7c02","284":"4cf4841","285":"91f411b","286":"7d3b504","287":"2fcf4d2","288":"a0f8199","289":"71f0012","290":"2fee070","291":"dc46e44","292":"49750c1","293":"296558b","294":"8be2f7b","295":"37c013a","296":"fd0c030","297":"1142f33","298":"761547b","299":"b40ecd0","300":"470189e","301":"d7b1926","302":"6efd52d","303":"3efbaf3","304":"a806414","305":"41465f0","306":"05b229f","307":"ab7236e","308":"56bb236","309":"88bad45","310":"866a729","311":"d428e7a","312":"14b79f7","313":"31ccb27","314":"66a6f39","315":"d64e802","316":"2d54b42","317":"46a5d33","318":"c9cd6c1","319":"6f592e9","320":"9fb46f0","321":"29b49cc","322":"a0963f4","323":"1e193a8","324":"a831a6f","325":"ffc2843","326":"7746e55"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://d1mf56q6wc1y19.cloudfront.net/channels2022/220519/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
